import { Button, Row } from 'antd'
import React from 'react'
import SubHeader from 'utils/subHeader'
import 'containers/routesMaster/App.css'
import { withRouter } from 'react-router'

class AutoClosure extends React.Component { 
  
    addAutoClosure = () => {
        this.props.history.push({
        pathname: '/auto-closure/add',
        search: this.props.location.search,
        })
    }

    cta = () => {
        return (
        <div>
            <Button style={{ marginLeft: 10 }} size="large" type="primary"
               onClick={this.addAutoClosure}
            >Add Auto Closure
            </Button>
        </div>
        )
    }

    render() {
        return (
        <Row>
            <SubHeader innerhtml={this.cta} />
              {this.props.children}
        </Row>
        )
    }
}

export default withRouter(AutoClosure)
